module.exports = __webpack_public_path__ + "static/media/progressGreyArrow.0f630b8d.svg";